import BaseTranslations from "../../common/BaseTranslations";

export default class DiscussionTranslations extends BaseTranslations {
  constructor(lang: string) {
    super(lang);
    this.data = {
      ru: {
        LOGIN_PROMPT: 'Чтобы отправить сообщение, необходимо авторизоваться',
        LOGIN_PROMPT_SHORT: 'Войдите, чтобы разместить комментарий',
        POST_TOO_SHORT: '<i class="fua-hf-icon-exclamation"></i>Комментарий должен содержать хотя бы две буквы',
        POST_NOT_APPROVED: 'Почти размещен! Первые 10 сообщений пользователя проходят проверку перед публикацией. Дайте нам пару часов.',
        SORT_HEADER: 'Комментарии (%s)',
        POST_UNSUCCESSFUL: 'Сообщение не опубликовано. Обратитесь к администрации форума.',
        POST_NOT_ALLOWED: 'Анонимные пользователи не могут отправлять сообщения'
      },
      uk: {
        LOGIN_PROMPT: 'Що б відправити повідомлення, необхідно авторизуватися',
        LOGIN_PROMPT_SHORT: 'Увійдіть, щоб розмістити коментар',
        POST_TOO_SHORT: '<i class="fua-hf-icon-exclamation"></i>Коментар має містити хоча б дві літери',
        POST_NOT_APPROVED: 'Майже розміщено! Перші 10 повідомлень користувача проходять перевірку перед публікацією. Дайте нам кілька годин.',
        SORT_HEADER: 'Коментарі (%s)',
        POST_UNSUCCESSFUL: 'Повідомлення не опубликовано. Зверніться до адміністрації форума.',
        POST_NOT_ALLOWED: 'Анонімні користувачі не можуть відправляти повідомлення'
      }
    }
  }
}
